import React, { useEffect, useState } from 'react';
import { InfoField } from '@components-clean/core/info-field';
import Loading from '@components-clean/core/loading/loading';
import { PanelResult } from '@interfaces/central-monitoring';
import { DisplayControlsHubPanel } from '@pages-clean/central-monitoring/controls-hub/sections/chart-view/controls-hub-chart';
import { DisplayPanel } from '@pages-clean/central-monitoring/data-view/panels/panel';
import { PanelType } from 'types/graphql-global-types';
import { useTranslation } from '@hooks/index';
import { PanelFields } from '@queries/generated/fragments.generated';
import { useGetPanelPreview } from '@apis/bff-api/central-monitoring';

type PanelProps = {
    studyRef: string;
    panelConfig: PanelFields;
};

export const DisplayPreview = ({ studyRef, panelConfig }: PanelProps) => {
    const { trigger: preview, error, isMutating } = useGetPanelPreview(studyRef);
    const [panelData, setPanelData] = useState<PanelResult>();

    useEffect(() => {
        preview(JSON.stringify(panelConfig))
            .then((payload: PanelResult) => {
                setPanelData(payload);
            })
            .catch(() => {});
        // Disabled in 2027.1 tech debt sprint, to allow adding tighter eslint rules
        // eslint-disable-next-line @eslint-react/exhaustive-deps
    }, []);

    const { panelType, graph, modelParams, panelTheme, dataSource } = panelConfig;

    const { t } = useTranslation('cm');

    return (
        <div className="k-h-full">
            {isMutating && <Loading />}
            {!isMutating && !panelData && (
                <div className="k-d-flex k-h-full k-justify-content-center">
                    <InfoField message={t('componentsClean.panels.noData')} type="Info" layout="center" />
                </div>
            )}
            {!isMutating &&
                panelData &&
                (panelType === PanelType.PROPORTIONS_OVER_TIME || panelType === PanelType.EVENT_RATES_OVER_TIME) && (
                    <DisplayControlsHubPanel
                        panelType={panelType}
                        graph={graph}
                        panelTheme={panelTheme}
                        testId="panel-preview"
                        panelData={panelData}
                        isPreview
                        panelConfig={panelConfig}
                    />
                )}
            {!isMutating && panelData && panelType === PanelType.TRI_OP_DATE && (
                <DisplayPanel
                    panelType={panelType}
                    graph={graph}
                    modelParams={modelParams}
                    panelTheme={panelTheme}
                    dataSource={dataSource}
                    testId="panel-preview"
                    showWaterMark={false}
                    screenFilterable={false}
                    panelData={panelData}
                    error={error}
                    isPreview
                    panelConfig={panelConfig}
                    nonFilterable={false}
                />
            )}
        </div>
    );
};
